const serviceUrl = "https://www.gmcabscard.com.au/services/api/"

const services = {
    login: serviceUrl + "public/token",
    signup: serviceUrl + "public/signup/create",
    profileimg: serviceUrl + "rest/profile/updatePicture",
    capcha: serviceUrl + "public/captcha",
    get_public_key: serviceUrl + "public/card/getkey/gmcabs",
    verify_card: serviceUrl + "public/card/verify",
    store_card: serviceUrl + "public/card/storeCard",
    activate_card: serviceUrl + "public/card/activate",
    secret_ques: serviceUrl + "public/signup/getAllSecretQuestions",
    update_user_info: serviceUrl + "public/card/updateUserSecurityInfo",
    get_cards: serviceUrl + "rest/card/getCards",
    find_member: serviceUrl + "rest/member/findMembers",
    add_friend: serviceUrl + "rest/member/addFriend",
    contactUsSubject: serviceUrl + "public/subjects",
    get_profile: serviceUrl + "rest/profile/read",
    update_basic: serviceUrl + "rest/profile/updateBasicInfo",
    update_contact: serviceUrl + "rest/profile/updateContactInfo",
    update_mailing: serviceUrl + "rest/profile/updateMailingInfo",
    get_friend: serviceUrl + "rest/member/getFriends",
    dlt_friend: serviceUrl + "rest/member/deleteFriend",
    edit_friend: serviceUrl + "rest/member/editFriend",
    change_password: serviceUrl + "rest/profile/changePassword",
    share_fund: serviceUrl + "rest/card/shareFunds",
    change_pin: serviceUrl + "rest/card/changePIN",
    get_userid: serviceUrl + "public/card",
    get_password: serviceUrl + "public/validateUserId",
    forgot_password: serviceUrl + "public/forgotPassword",
    block_card: serviceUrl + "rest/card/setCardStatus",
    country: serviceUrl + "public/signup/country",
    change_seq_que: serviceUrl + "rest/profile/updateSecretQA",
    send_userid: serviceUrl + "public/getUserId",
    get_transactionid: serviceUrl + "rest/card/transactionHistory",
    get_alerts: serviceUrl + "rest/card/readAlerts",
    deb_txnpost_alert: serviceUrl + "rest/card/debitTxnPostAlert",
    cdt_txnpost_alert: serviceUrl + "rest/card/creditTxnPostAlert",
    card_bal_alert: serviceUrl + "rest/card/cardBalanceAlert",
    insuf_bal_alert: serviceUrl + "rest/card/NonSufficientFundsAlert",
    other_alert: serviceUrl + "rest/card/updateCardAlert",
    get_cardactivity: serviceUrl + "rest/card/getCardActivity",
    contact_us: serviceUrl + "public/contactus",
    valid_user_id: serviceUrl + "public/signup/verifyUserName",
    update_forceSecret: serviceUrl + "rest/profile/forceSecretQAUpdate",
    card_detail_service: serviceUrl + "rest/card/detailsByCardReferenceId",
    update_card_status: serviceUrl + "rest/card/updateCardStatusByRefId",
    update_emailid: serviceUrl + "rest/profile/updateEmailAddress",
    userid_info: serviceUrl + "rest/card/detailsByUserId",
    mobno_info: serviceUrl + "rest/card/detailsByMobileNumber",
    send_api_link: serviceUrl + "public/sendMobileAppLink",
    resetsq_card_verify: serviceUrl + "public/verifyCardNumber",
    resetsq_expiry_verify: serviceUrl + "public/verifyExpiryDate",
    resetsq_mobNum_verify: serviceUrl + "public/verifyMobileNumber",
    resetsq_dob_verify: serviceUrl + "public/verifyDateOfBirth",
    resetsq_qa: serviceUrl + "public/resetSecretQA",
    update_cardholder_info: serviceUrl + "rest/profile/updateProfile"

}

export default services;



// WEBPACK FOOTER //
// ./src/services/allservices.jsx